import { elements } from '@ecosystem/newron-design-system';
import React from 'react';
import { MenuButtonProps } from '../selection.menu';
import classNames from 'classnames';
import { useMobile } from '../../context/mobile/mobile.provider';

function TitleSelectorButton({ onClick, children }: MenuButtonProps) {
  const { Icon } = elements;
  const { isMobile } = useMobile();
  return (
    <button
      className={classNames('text-left  text-brand p-0 flex items-center transition-colors hover:text-brand-dark', {
        'text-lg': !isMobile,
        'text-md': isMobile,
      })}
      onClick={onClick}
    >
      <span className="flex-grow">{children}</span>
      <Icon color="brand" size="sm">
        <Icon.icons.ChevronDown />
      </Icon>
    </button>
  );
}

export { TitleSelectorButton };
